import { z } from "zod";
import { THEME_IDS } from "../themes.js";

export const eventInputSchema = z.object({
  name: z.string().min(1).max(120),
  date: z.coerce.date(),
  location: z.string().max(200).optional().or(z.literal("")),
  theme: z.enum(THEME_IDS),
  // Fenêtre de contribution des invités (sinon : début = date, fin = date + 6 h).
  captureStartAt: z.coerce.date().optional(),
  captureEndAt: z.coerce.date().optional(),
  // Moment de révélation de la galerie (sinon : date + 24 h).
  revealAt: z.coerce.date().optional(),
  // Message affiché sur l'écran de projection.
  wallMessage: z.string().max(500).optional().or(z.literal("")),
  // Mur des invités (fil + likes).
  wallEnabled: z.boolean().optional(),
});
export type EventInput = z.infer<typeof eventInputSchema>;

export const updateEventSchema = eventInputSchema
  .partial()
  .refine(
    (v) => !v.captureStartAt || !v.captureEndAt || v.captureStartAt < v.captureEndAt,
    { message: "La fin doit être après le début", path: ["captureEndAt"] },
  );
export type UpdateEventInput = z.infer<typeof updateEventSchema>;

/** État de la fenêtre de contribution, calculé côté serveur. */
export type CaptureState = "before" | "open" | "closed";
